import React, { useState, useEffect } from "react";
import LoginAndRegister from "components/UnauthorizedComponents/LoginAndRegister";
import { Router, navigate } from "@reach/router";
import NavBar from "components/common/NavBar";
import Footer from "components/common/Footer";
import Store from "redux/store";
import "components/UnauthorizedComponents/unauthenticatedApp.css";

export default function UnauthenticatedApp() {
  const [showSidebar, setShowSidebar] = useState();

  const sidebarVisible = () => {
    if (window.innerWidth > 768) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    window.onresize = () => {
      setShowSidebar(sidebarVisible());
    };
    setShowSidebar(sidebarVisible());
  }, []);

  const clicked = (to) => {
    navigate(to);
    Store.dispatch({
      type: "showSidebar",
      payload: false,
    });
  };

  return (
    <div className="unauthenticated-app App">
      <div className={`${showSidebar ? "sidebar" : ""}`}>
        <div className="sidebar-wrapper">
          <ul className="nav navbar-nav nav-mobile-menu">
            <li className="nav-item">
              <div
                to="/login"
                className="nav-link"
                onClick={() => {
                  clicked("/login");
                }}
                style={{ marginLeft: 10 }}
              >
                Login
              </div>
            </li>
            <li className="nav-item">
              <div
                to="/register"
                className="nav-link"
                onClick={() => {
                  clicked("/register");
                }}
                style={{ marginLeft: 10 }}
              >
                Register
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="main-panel unauthorized-main">
        <NavBar authenticated={false} />
        <header className="masthead text-white text-center">
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col-xl-12 mx-auto">
                {window.location.href.match(/login|register/) ? (
                  <Router>
                    <LoginAndRegister path="login" />
                  </Router>
                ) : (
                  <>
                    <h1 className="mb-5">WE LOVE ENTREPRENEURS</h1>
                    <p>
                      At <b>Venture Garage</b>, we handhold early stage startups
                      to raise capital from our network of 2500+ Investors.
                    </p>
                    <p>
                      <b>Our Investor Network Includes:</b> VCs, HNIs, Family
                      Offices, Strategic Investors, Corporates, Angel & Seed
                      Investors who invest between $50K to 15Mil in Seed to
                      Series A/B rounds.
                    </p>
                    <p>
                      <b>VG-Angels</b> is the angel network of Venture Garage
                    </p>
                    <p>
                      <b>VG-Corporate</b> partners with large enterprises to
                      acquire startups
                    </p>
                    <div className="logos grid">
                      <a href="https://venturegarage.in/" target="_blank">
                        <img src="/logos/logo-main-transparent.png" alt="" />
                      </a>
                      <a
                        href="https://venturegarage.in/vgangels/"
                        target="_blank"
                      >
                        <img src="/logos/logo-with-plane.png" alt="" />
                      </a>
                      <a
                        href="https://venturegarage.in/vgcorporate/"
                        target="_blank"
                      >
                        <img src="/logos/vg-corporate.png" alt="" />
                      </a>
                    </div>
                  </>
                )}
              </div>
              <div className="col-md-10 col-lg-8 col-xl-7 mx-auto"></div>
            </div>
          </div>
        </header>
        <Footer />
      </div>
    </div>
  );
}
